import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ArrowLeftIcon } from 'lucide-react';
import type { JSX } from 'react';

import { useBackNavigation } from '../../routing';
import { AppLinkOptions } from '../../routing/links/linkOptions';
import { SecondaryButton } from './SecondaryButton';
import { TertiaryIconButton } from './TertiaryIconButton';

export type BackButtonProps = {
    /** Where to go when there is nowhere in the app to go back to. Build it with `linkOptions()`. */
    fallback: AppLinkOptions;
    variant?: 'icon' | 'button';
    size?: 'small' | 'medium';
};

export function BackButton({ variant = 'icon', size = 'medium', fallback }: BackButtonProps): JSX.Element {
    const { navigateBack } = useBackNavigation();
    const goBack = () => navigateBack({ fallback });

    if (variant === 'icon') {
        return (
            <TertiaryIconButton size={size} aria-label={t`Back`} onClick={goBack}>
                <ArrowLeftIcon />
            </TertiaryIconButton>
        );
    } else {
        return (
            <SecondaryButton
                size={size}
                onClick={goBack}
                startIcon={<ArrowLeftIcon />}
                style={{ width: 'fit-content' }}
            >
                <Trans>Back</Trans>
            </SecondaryButton>
        );
    }
}
